import styled, { css } from 'styled-components';

import { fontSize, FontSizes, FontWeights, maxWidth, minWidth, Text, units } from '@calm-web/design-system';

export const TextWrapper = styled.div<{ $isCoveredLivesPage: boolean }>`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	text-align: center;
	margin: ${p => (p.$isCoveredLivesPage ? units(3, 0) : units(0, 1))};
	min-height: ${units(14)};
	margin-top: ${units(3)};
	width: 560px;

	${maxWidth('desktop')} {
		margin: ${units(0, 1, 1, 1)};
		min-height: ${units(14)};
	}
	${maxWidth('tablet')} {
		padding: ${units(0, 2)};
		width: 100%;
	}
	${maxWidth('mobileLarge')} {
		min-height: ${units(14)};
		padding: ${units(0, 2)};
	}
`;

export const StyledText = styled(Text).attrs({
	el: 'h1',
	size: FontSizes['2xl'],
	color: 'text',
	weight: FontWeights.Medium,
	noMargin: true,
})<{ $isCoveredLivesPage?: boolean }>`
	${props =>
		props.$isCoveredLivesPage &&
		css`
			line-height: 38px;
		`}

	${minWidth('desktop')} {
		margin-bottom: ${units(1)};
	}

	${maxWidth('mobileLarge')} {
		width: 100%;
		${fontSize(FontSizes['2xl'])};
	}
`;

export const StyledSubText = styled(Text).attrs({
	el: 'p',
	weight: FontWeights.Regular,
	color: 'gray6',
})<{ $isCoveredLivesPage?: boolean }>`
	${props =>
		props.$isCoveredLivesPage &&
		css`
			font-size: 16px;
			line-height: 24px;
			letter-spacing: 0.15px;

			${maxWidth('mobileLarge')} {
				margin-bottom: ${units(2)};
			}
		`}
`;
